/* eslint-disable react/destructuring-assignment,react/no-access-state-in-setstate,jsx-a11y/click-events-have-key-events,jsx-a11y/no-static-element-interactions,react/no-array-index-key */

import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';

import { FontAwesome } from '../../components/FontAwesome';
import { ScrollButton } from '../../components/Links/ScrollButton';
import {
  PortalCourseLinksPropType,
  PortalInstitutionPropType,
} from '../../../CustomPropTypes/PortalPropTypes';
import { LoadableResponsiveImage as ResponsiveImage } from '../../components/ResponsiveImage/LoadableResponsiveImage';
import './PortalMobileNavBar.scss';

class _PortalMobileNavBar extends React.Component {
  static displayName = 'PortalMobileNavBar';

  static propTypes = {
    portalInstitution: PortalInstitutionPropType.isRequired,
    links: PortalCourseLinksPropType.isRequired,
    t: PropTypes.func.isRequired,
    callToAction: PropTypes.string,
  };

  static defaultProps = {
    callToAction: '',
  };

  state = {
    expanded: false,
  };

  toggleMenu = () => {
    this.setState({ expanded: !this.state.expanded });
  };

  translatedTitle = (title) => {
    const { t, callToAction } = this.props;

    switch (title) {
      case 'About':
        return callToAction ? t('about') : title;
      case 'Outcomes':
        return callToAction ? t('outcomes') : title;
      case 'Instructors':
        return callToAction ? t('instructors') : title;
      case 'Certification':
        return callToAction ? t('certification') : title;
      case 'FAQ':
        return callToAction ? t('faq') : title;
      default:
        return title;
    }
  };

  render() {
    const { portalInstitution, links } = this.props;
    const { expanded } = this.state;

    return (
      <portal-mobile-nav-bar>
        <header>
          <div className="row">
            <div className="columns small-12 medium-10 medium-centered">
              <div className="nav-bar-wrapper">
                {portalInstitution.get('logoUrl') && (
                  <a
                    className="institution-logo"
                    href={portalInstitution.get('url')}
                  >
                    <ResponsiveImage
                      src={portalInstitution.get('logoUrl')}
                      resize="h:80"
                    />
                  </a>
                )}
                {links.size > 0 && (
                  <span className="expander" onClick={this.toggleMenu}>
                    <FontAwesome
                      name={expanded ? 'chevron-up' : 'chevron-down'}
                    />
                  </span>
                )}
              </div>
            </div>
          </div>
          {expanded && (
            <div className="row nav-bar-links-wrapper">
              <div className="columns small-11 small-centered medium-10 medium-centered">
                <ul className="nav-bar-links">
                  {links.map((link, index) => (
                    <li key={index}>
                      <ScrollButton
                        activeClass="active"
                        to={link.get('link').replace('#', '')}
                        smooth
                        duration={500}
                        onClick={this.toggleMenu}
                      >
                        {this.translatedTitle(link.get('title'))}
                      </ScrollButton>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          )}
        </header>
      </portal-mobile-nav-bar>
    );
  }
}

export const PortalMobileNavBar = withTranslation('landingPages')(
  _PortalMobileNavBar
);
